import { render, staticRenderFns } from "./waterMonitorForm.vue?vue&type=template&id=3af4e424&scoped=true&"
import script from "./waterMonitorForm.vue?vue&type=script&lang=ts&"
export * from "./waterMonitorForm.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3af4e424",
  null
  
)

export default component.exports